import React from "react";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import LocalAttractions from "./pages/LocalAttractions";
import Accommodations from "./pages/Accommodations";
import Restaurant from "./pages/Restaurant";
import Events from "./pages/Events";
import Spa from "./pages/Spa";
import Activities from "./pages/Activities";
import BookingWidgetTest from "./pages/BookingWidgetTest";
import Book from "./pages/Book";
import BestRateGuarantee from "./pages/BestRateGuarantee";
import TestMewsApi from "./pages/TestMewsApi";
import TestMewsConfig from "./pages/TestMewsConfig";
import NotFound from "./pages/NotFound";
import Journal from "./pages/Journal";
import JournalPostPage from "./pages/JournalPost";
import { RequireLocalizedLang } from "./components/RequireLocalizedLang";

export const AppRoutes = () => (
  <Routes data-oid="rv0eo1w">
    {/* English routes (default - no prefix) */}
    <Route path="/" element={<Index data-oid="purpxye" />} data-oid="u1bdrbd" />
    <Route
      path="/accommodations"
      element={<Accommodations data-oid="su9e.mn" />}
      data-oid="k1ahxzv"
    />

    {/* Journal Routes (English) */}
    <Route path="/journal" element={<Journal />} />
    <Route path="/journal/:slug" element={<JournalPostPage />} />

    <Route
      path="/local-attractions"
      element={<LocalAttractions data-oid="ii2ybz6" />}
      data-oid="la8ykay"
    />

    <Route
      path="/dining"
      element={<Restaurant data-oid="s7e07b." />}
      data-oid="zvw-wrp"
    />

    <Route
      path="/events"
      element={<Events data-oid="wvc9hbe" />}
      data-oid="dc-92bw"
    />

    <Route
      path="/spa"
      element={<Spa data-oid="dt9r086" />}
      data-oid="9tb7ule"
    />

    <Route
      path="/activities"
      element={<Activities data-oid="act-1" />}
      data-oid="act-2"
    />

    <Route
      path="/test-booking-widget"
      element={<BookingWidgetTest data-oid="4c4641s" />}
      data-oid="uzgm_7y"
    />

    <Route path="/book" element={<Book data-oid="book-en" />} data-oid="book-en-rt" />
    <Route
      path="/best-rate-guarantee"
      element={<BestRateGuarantee />}
      data-oid="brg-en-rt"
    />
    <Route
      path="/test-mews-api"
      element={<TestMewsApi />}
      data-oid="test-mews-api-rt"
    />
    <Route
      path="/test-mews-config"
      element={<TestMewsConfig />}
      data-oid="test-mews-config-rt"
    />

    {/* Language-prefixed routes (German & French only — see RequireLocalizedLang) */}
    <Route
      path="/:lang"
      element={
        <RequireLocalizedLang>
          <Index data-oid="toxh5hy" />
        </RequireLocalizedLang>
      }
      data-oid="ymck9p."
    />

    <Route
      path="/:lang/journal"
      element={
        <RequireLocalizedLang>
          <Journal />
        </RequireLocalizedLang>
      }
    />
    <Route
      path="/:lang/journal/:slug"
      element={
        <RequireLocalizedLang>
          <JournalPostPage />
        </RequireLocalizedLang>
      }
    />

    <Route
      path="/:lang/book"
      element={
        <RequireLocalizedLang>
          <Book data-oid="book-lang" />
        </RequireLocalizedLang>
      }
      data-oid="book-lang-rt"
    />

    <Route
      path="/:lang/best-rate-guarantee"
      element={
        <RequireLocalizedLang>
          <BestRateGuarantee />
        </RequireLocalizedLang>
      }
      data-oid="brg-lang-rt"
    />

    <Route
      path="/:lang/accommodations"
      element={
        <RequireLocalizedLang>
          <Accommodations data-oid="qgq1.e1" />
        </RequireLocalizedLang>
      }
      data-oid="aemy7p3"
    />

    <Route
      path="/:lang/local-attractions"
      element={
        <RequireLocalizedLang>
          <LocalAttractions data-oid=".ofgbhp" />
        </RequireLocalizedLang>
      }
      data-oid="m_qy6a:"
    />

    <Route
      path="/:lang/dining"
      element={
        <RequireLocalizedLang>
          <Restaurant data-oid="lrimq70" />
        </RequireLocalizedLang>
      }
      data-oid="8kw9sax"
    />

    <Route
      path="/:lang/events"
      element={
        <RequireLocalizedLang>
          <Events data-oid="rntx5e7" />
        </RequireLocalizedLang>
      }
      data-oid="bvsyq2v"
    />

    <Route
      path="/:lang/spa"
      element={
        <RequireLocalizedLang>
          <Spa data-oid="v0k6_ba" />
        </RequireLocalizedLang>
      }
      data-oid="e9s3tyi"
    />

    <Route
      path="/:lang/activities"
      element={
        <RequireLocalizedLang>
          <Activities data-oid="act-3" />
        </RequireLocalizedLang>
      }
      data-oid="act-4"
    />

    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route
      path="*"
      element={<NotFound data-oid="24jg8d3" />}
      data-oid="y9qgfe8"
    />
  </Routes>
);
